<template>
  <div id="display" class="article-display-container">
    <div class="article-display" :class="classes">
      <div>
        <div class="two-images-top">
          <div>
            <Picture v-if="imageZero" :images="imageZero" />
          </div>
          <div>
            <AddFromPhoto
              v-if="productHandle"
              :product-handle="productHandle"
              :image-url="imageOne"
            />
            <Picture v-else :images="imageOne" />
          </div>
        </div>
        <div class="single-image">
          <IntersectionObserver v-if="videoUrl2" v-slot="{ intersected }">
            <Video
              :intersected="intersected"
              :video="{
                sources: [
                  {
                    url: videoUrl2,
                  },
                ],
              }"
            />
          </IntersectionObserver>
          <AddFromPhoto
            v-if="productHandle2"
            :product-handle="productHandle2"
            :image-url="imageTwo"
          />
          <Picture v-else-if="imageTwo" :images="imageTwo" />
          <div v-if="credit1" class="credit">{{ credit1 }}</div>
        </div>
        <div>
          <div class="two-images">
            <div class="image-three">
              <AddFromPhoto
                v-if="productHandle3"
                :product-handle="productHandle3"
                :image-url="imageThree"
              />
              <Picture v-else :images="imageThree" />
              <div v-if="credit4" class="credit">{{ credit4 }}</div>
            </div>
            <div>
              <div v-if="productHandle4">
                <AddFromPhoto
                  :product-handle="productHandle4"
                  :image-url="imageFour"
                />
              </div>
              <div v-else>
                <Picture :images="imageFour" />
                <div v-if="credit3" class="credit3">{{ credit3 }}</div>
              </div>
            </div>
          </div>
          <div v-if="text" class="article-text">
            <div class="wysiwyg" v-html="text"></div>
          </div>
          <div v-else class="slot-left wysiwyg">
            <slot name="left" />
          </div>
        </div>
      </div>
      <div>
        <AddFromPhoto
          v-if="productHandle5"
          :product-handle="productHandle5"
          :image-url="imageFive"
        />
        <Picture v-else :images="imageFive" />
        <IntersectionObserver v-if="videoUrl" v-slot="{ intersected }">
          <Video
            :intersected="intersected"
            :video="{
              sources: [
                {
                  url: videoUrl,
                },
              ],
            }"
          />
        </IntersectionObserver>
        <div v-if="quote" class="quote">
          <p class="quote__text">"{{ quote }}"</p>
          <p v-if="author" class="author">{{ author }}</p>
        </div>
        <div v-else class="slot-right">
          <slot name="right" />
        </div>
        <div class="image-six">
          <IntersectionObserver v-if="videoUrl3" v-slot="{ intersected }">
            <Video
              :intersected="intersected"
              :video="{
                sources: [
                  {
                    url: videoUrl3,
                  },
                ],
              }"
            />
          </IntersectionObserver>
          <AddFromPhoto
            v-if="productHandle6"
            :product-handle="productHandle6"
            :image-url="imageSix"
          />
          <Picture v-else-if="imageSix" :images="imageSix" />
          <div v-if="credit2" class="credit">{{ credit2 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromPhoto from "@/components/AddFromPhoto.vue";
import Video from "@/components/Video.vue";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
export default {
  name: "ArticleDisplay",
  components: {
    Picture,
    AddFromPhoto,
    IntersectionObserver,
    Video,
  },
  props: {
    imageZero: {
      type: Object,
      default: null,
    },
    imageOne: {
      type: Object,
      default: null,
    },
    imageTwo: {
      type: Object,
      default: null,
    },
    imageThree: {
      type: Object,
      default: null,
    },
    imageFour: {
      type: Object,
      default: null,
    },
    imageFive: {
      type: Object,
      default: null,
    },
    imageSix: {
      type: Object,
      default: null,
    },
    videoUrl: {
      type: String,
      default: null,
    },
    videoUrl2: {
      type: String,
      default: null,
    },
    videoUrl3: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    quote: {
      type: String,
      default: null,
    },
    author: {
      type: String,
      default: null,
    },
    productHandle: {
      type: String,
      default: null,
    },
    productHandle2: {
      type: String,
      default: null,
    },
    productHandle3: {
      type: String,
      default: null,
    },
    productHandle4: {
      type: String,
      default: null,
    },
    productHandle5: {
      type: String,
      default: null,
    },
    productHandle6: {
      type: String,
      default: null,
    },
    credit1: {
      type: String,
      default: null,
    },
    credit2: {
      type: String,
      default: null,
    },
    credit3: {
      type: String,
      default: null,
    },
    credit4: {
      type: String,
      default: null,
    },
    creditGradient: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        "article-display--creditGradient": this.creditGradient,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-display {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 10px 10px 50px;

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 auto;
    max-width: 1200px;
    padding: 0 0 80px;
  }

  &--creditGradient {
    .image-three {
      &::after {
        content: "";
        background: linear-gradient(
          180deg,
          rgba(89, 89, 89, 0) 0%,
          rgba(1, 1, 1, 0.6) 100%
        );
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 75%;
      }
    }
    .credit {
      bottom: 20px;
      color: $color-white;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.49px;
      left: 20px;
      position: absolute;
      z-index: 1;
    }
  }
}

.article-text,
.slot-left {
  padding: 20px 10px;
  @include t__editorial-body-10;

  @include respond-above(md) {
    @include t__editorial-body-20;
    padding: 100px 0 0 0;
    max-width: 80%;
  }
}

.slot-right :deep() {
  color: $color-grey-dark;
  @include t__editorial-body-10;
  padding: 40px 10px 40px 10px;
  text-align: left;

  @include respond-above(md) {
    @include t__editorial-body-10;
    padding: 100px 60px;
  }

  h4 {
    @include t__editorial-headline-10;
    margin-bottom: 10px;

    @include respond-above(md) {
      @include t__editorial-headline-20;
    }
  }
  p {
    @include t__editorial-body-10;
    margin-bottom: 20px;
    @include respond-above(md) {
      @include t__editorial-body-20;
    }
  }
}

.single-image {
  margin: 0 0 2px 0;
  position: relative;

  @include respond-above(md) {
    margin: 0 0 20px 0;
  }
}

.two-images {
  @include respond-above(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    position: relative;
  }
}

.two-images-top {
  @include respond-above(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding-bottom: 20px;
  }
}

.right-aligned-image {
  margin: 0 0 2px 0;
  @include respond-above(md) {
    display: flex;
    margin: 0 0 20px 50%;
    width: 50%;
  }
}

.video {
  margin: 0 0 2px 0;
  @include respond-above(md) {
    display: inline-block;
    position: relative;
    width: 100%;
  }
}

.quote {
  padding: 40px 10px;
  text-align: center;

  @include respond-above(md) {
    padding: 130px 60px;
  }

  &__text {
    color: $color-grey-dark;
    @include t__editorial-sub-headline-30;
    margin: 0 0 30px 0;
  }

  &__author {
    color: $color-grey-dark;
    @include t__utility-label-30;
  }
}

.author {
  @include t__utility-label-30;
  margin: 15px 0 0 0;

  @include respond-above(md) {
    margin: 20px 0 0 0;
  }
}

.wysiwyg :deep() {
  color: $color-grey-dark;

  h4 {
    @include t__editorial-headline-10;
    margin-bottom: 10px;

    @include respond-above(md) {
      @include t__editorial-headline-20;
    }
  }

  p {
    @include t__editorial-body-10;
    margin-bottom: 20px;
    @include respond-above(md) {
      @include t__editorial-body-20;
    }
  }

  *:last-child {
    margin-bottom: 0;
  }
}

.image-six {
  position: relative;
}

.image-three {
  position: relative;
}
.credit {
  bottom: 20px;
  color: $color-white;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.49px;
  left: 20px;
  position: absolute;
}
.credit3 {
  bottom: 20px;
  color: $color-white;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.49px;
  right: 110px;
  position: absolute;
}
</style>
